import { useEffect, useReducer } from "react";
import { IAlert } from "../../interfaces/alert";
import { ERROR, GET, INFO, ROWS_PER_PAGE } from "../../utils/constants";
import { fetchData } from "../../utils/dataProvider";
import { feesReducer, IFeesStates } from "../../reducers/feesReducer";
import FeesTabView from "./FeesTabView";

const initialValues: IFeesStates = {
  fees: [],
  count: 0,
  loading: true,
  alert: {} as IAlert,
  openModal: false,
  selectedAction: "create",
  selectedFee: null,
  page: 0,
};

const FeesTabContainer = () => {
  const [states, dispatch] = useReducer(feesReducer, initialValues);
  const {
    fees,
    count,
    loading,
    alert,
    openModal,
    selectedAction,
    selectedFee,
    page,
  } = states;

  const handleGetFees = async (searchValue?: string) => {
    dispatch({ type: "setLoading", value: true });
    const skip = page * ROWS_PER_PAGE;
    try {
      const { list: customizationFees, count: feesCount } = await fetchData({
        url: `/customization_fees?limit=${ROWS_PER_PAGE}&skip=${
          searchValue ? "0" : skip
        }${searchValue ? `&name=${searchValue}` : ""}`,
        method: GET,
      });
      dispatch({ type: "setFees", value: customizationFees });
      dispatch({ type: "setCount", value: feesCount });
      const newAlert = feesCount
        ? ({} as IAlert)
        : ({
          typeOfAlert: INFO,
          message: "No hay tarifas para mostrar.",
          showAlert: true,
        } as IAlert);
      dispatch({ type: "setAlert", value: newAlert });
    } catch (error: any) {
      dispatch({
        type: "setAlert",
        value: {
          typeOfAlert: ERROR,
          message: error?.message || error,
          showAlert: true,
        },
      });
    } finally {
      dispatch({ type: "setLoading", value: false });
    }
  };

  const handleCreateFeeRule = () => {
    dispatch({ type: "setSelectedAction", value: "create" });
    dispatch({ type: "setOpenModal", value: true });
  };

  const handlePageChange = (newPage: number) =>
    dispatch({ type: "setPage", value: newPage });

  const handleOpenEditModal = () => {
    dispatch({ type: "setSelectedAction", value: "edit" });
    dispatch({ type: "setOpenModal", value: true });
  };

  const viewProps = {
    handleGetFees,
    handleCreateFeeRule,
    loading,
    alert,
    fees,
    dispatch,
    handlePageChange,
    page,
    count,
    openModal,
    selectedAction,
    selectedFee,
  };

  useEffect(() => {
    handleGetFees();
  }, [page]);

  useEffect(() => {
    if (selectedFee) handleOpenEditModal();
  }, [selectedFee]);

  return <FeesTabView {...viewProps} />;
};

export default FeesTabContainer;
